import { render, staticRenderFns } from "./tre-more.vue?vue&type=template&id=30484dc2&scoped=true&"
import script from "./tre-more.vue?vue&type=script&lang=js&"
export * from "./tre-more.vue?vue&type=script&lang=js&"
import style0 from "./tre-more.vue?vue&type=style&index=0&id=30484dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30484dc2",
  null
  
)

export default component.exports